<h1 mat-dialog-title>Rezerwacje do kwaterowania</h1>

<div mat-dialog-content>
	<table>
		<thead>
			<tr>
				<th>Imię</th>
				<th>Nazwisko</th>
				<th>Data urodzenia</th>
				<th>Od</th>
				<th>Do</th>
				<th>Rezerwacja</th>
				<th>Status</th>
				<th>Kwateruj</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let pos of reservations">
				<td>{{ pos?.firstName }}</td>
				<td>{{ pos?.lastName }}</td>
				<td>{{ pos?.birthDate }}</td>
				<td>{{ pos?.dateFrom | formatDateTime }}</td>
				<td>{{ pos?.dateTo | formatDateTime }}</td>
				<td>{{ pos?.businessCaseNumber }}</td>
				<td>{{ pos?.status }}</td>
				<td>
					<button mat-button mat-dialog-close color="primary" (click)="doc(pos)">
						<i class="fas fa-share-square"></i> Dokwateruj
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div mat-dialog-actions class="mt-3">
	<button mat-button mat-dialog-close>Zamknij</button>
</div>
